import script from "./detail-sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-sidebar.vue?vue&type=script&setup=true&lang=js"

import "./detail-sidebar.vue?vue&type=style&index=0&id=462f7f09&lang=css"

const __exports__ = script;

export default __exports__